/**
 * Checks if the app is running in webview mode by examining URL parameters.
 * This is the source of truth for webview mode detection.
 *
 * @returns true if the app is running in webview mode, false otherwise
 */
export function isWebViewMode(): boolean {
  const urlParams = new URLSearchParams(window.location.search);
  const isWebView = urlParams.get('isWebView');

  if (!isWebView) {
    return false;
  }

  if (isWebView.toLowerCase() === 'false') {
    return false;
  }

  return true;
}
